import * as React from "react";

function Landing() {
  return (
    <div className="flex flex-col justify-center text-white w-full ">
      <div className="flex overflow-hidden relative flex-col items-center px-16 pt-6 pb-14 w-full min-h-[300px] md:min-h-[calc(100vh-400px)] lg:min-h-[calc(100vh-100px)]  max-md:px-5 max-md:max-w-full">
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/96ca385bdbc338087d42b8370e4cff6f851af68a3ed0f9f32dc8022a767c5a50?apiKey=b3217365a35d45c196e47ed20ac8b87c&"
          alt="Background"
          className="absolute inset-0 size-full"
        />
       
      </div>
    </div>
  );
}

export default Landing;
